export const PageContentContainer = ({ children }) => (
  <div className="flex gap-10 w-fit justify-center item-center mb-8">{children}</div>
)
